import { createCarousel } from '~/components/carousel';
import { query } from '~/lib/utils/dom';
import { createTrapper } from '~/lib/utils/focus-trapper';
export const createImageCarousel = (els) => {
    const swiper = createCarousel(els.carousel);
    const { trap, untrap } = createTrapper(els.modal.main);
    const open = (img) => {
        els.modal.image.src = img.src;
        els.modal.image.alt = img.alt;
        els.modal.image.hidden = false;
        els.main.dataset.modalOpen = 'true';
        document.body.dataset.imageCarouselModalOpen = 'true';
        els.modal.main.inert = false;
        trap();
        requestAnimationFrame(addCloseListeners);
    };
    const close = () => {
        els.modal.image.src = '';
        els.modal.image.alt = '';
        els.modal.image.hidden = true;
        els.main.dataset.modalOpen = 'false';
        document.body.dataset.imageCarouselModalOpen = 'false';
        els.modal.main.inert = true;
        untrap();
        removeCloseListeners();
    };
    const onClickOff = (ev) => {
        if (!(ev.target instanceof Node) || els.modal.image.contains(ev.target)) {
            return;
        }
        close();
    };
    const onEscape = (ev) => {
        if (ev.key !== 'Escape') {
            return;
        }
        close();
    };
    const addCloseListeners = () => {
        addEventListener('click', onClickOff);
        addEventListener('keydown', onEscape);
    };
    const removeCloseListeners = () => {
        removeEventListener('click', onClickOff);
        removeEventListener('keydown', onEscape);
    };
    const listenToSlide = (slide) => {
        const img = query('.js-image-carousel-image', slide);
        const url = img.dataset.imgFullUrl;
        if (!url) {
            return;
        }
        slide.addEventListener('click', () => open({
            src: url,
            alt: img.alt,
        }));
    };
    swiper.slides.forEach(listenToSlide);
    els.modal.closeBtn.addEventListener('click', close);
    return {
        swiper,
        open,
        close,
    };
};
